import type { SavePermissionsRequestProps } from '@services/api/accessProfile/types'
import type { AccessProfileModalFormProps } from '../components/AccessProfileModal/form/types'

export const parseSavePermissionsPaylod = (data: AccessProfileModalFormProps) => {
  const payload: SavePermissionsRequestProps = {
    routeParams: {
      profileId: data.profileId?.toString() || ''
    },
    bodyParams: {
      hasFullModuleAccess: !!data.fullAccess,
      permissions: Object.keys(data.permissions!).map((item: any) => ({
        menuItemId: Number(item),
        totalPermission: data.permissions![Number(item)][0].value,
        canApprove: data.permissions![Number(item)][1].value,
        canEdit: data.permissions![Number(item)][2].value,
        canCreate: data.permissions![Number(item)][3].value,
        canView: data.permissions![Number(item)][4].value,
        canDelete: data.permissions![Number(item)][5].value
      })),
      observations: data.observations || '',
      profileType: data.profileType || '',
      profileName: data.profileDescription || '',
      isActive: !!(data.status == 'Ativo')
    }
  }

  return payload
}
